var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-overlay",class:{'loading-overlay__hasColumns': _vm.hasColumns, 'loading-overlay__noSpace': _vm.noSpace}},[_c('loading-skeleton',{attrs:{"type":"card","card":{ shape: 'square' }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }